module.exports = __webpack_public_path__ + "img/流体力学4_6_1.5d78aa81.jpg";